var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInflexionHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0440474 16.2349C0.0440474 14.8894 0.578565 13.5989 1.53001 12.6475C2.48146 11.696 3.77191 11.1615 5.11746 11.1615V16.2349H13.2349V0C13.2349 2.15288 12.3797 4.21759 10.8574 5.73991C9.33505 7.26223 7.27034 8.11746 5.11746 8.11746C2.96458 8.11746 0.899868 8.97269 -0.622451 10.495C-2.14477 12.0173 -3 14.082 -3 16.2349H0.0440474Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1908 0H5.11743V5.07341C6.46298 5.07341 7.75343 4.53889 8.70488 3.58744C9.65633 2.636 10.1908 1.34555 10.1908 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflexionHeaderLogo);
export default __webpack_public_path__ + "static/media/inflexion-header-logo.0007cd33bdd9626e49f7fb3159dd01e2.svg";
export { ForwardRef as ReactComponent };